import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para animações de entrada/saída em modais.
 * Retorna `visible` (controla a renderização) e `animating` (controla as classes CSS).
 * Chama `onClose` após a animação de saída terminar.
 */
export function useModalAnimation(onClose: () => void, durationMs = 200) {
  const [animating, setAnimating] = useState(false);

  // Dispara a animação de entrada logo após montar
  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      setAnimating(true);
    });
    return () => cancelAnimationFrame(raf);
  }, []);

  const handleClose = useCallback(() => {
    setAnimating(false);
    const timer = setTimeout(() => {
      onClose();
    }, durationMs);
    return () => clearTimeout(timer);
  }, [onClose, durationMs]);

  return { animating, handleClose };
}
